import { createStore } from 'redux';
import { appReducer } from '../model';

const store = createStore(
  appReducer,
  window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__(),
);

export default store;



// WEBPACK FOOTER //
// ./src/store/store.js